const Resources = [
  {
    categoryName: 'Articles and Books',
    links: [
      {
        title: 'Clean Code Javascript',
        url: 'https://github.com/ryanmcdermott/clean-code-javascript'
      },
      {
        title: 'CSS Weekly',
        url: 'https://css-weekly.com/'
      },
      {
        title: 'Five Best Design Links, Everyday',
        url: 'https://sidebar.io/'
      },
      {
        title: 'Dev and Design Articles',
        url: 'https://tympanus.net/codrops/'
      },
      {
        title: 'CSS3, JS & HTML5 Articles',
        url: 'http://www.standardista.com/'
      },
      {
        title: 'refactoring UI',
        url: 'https://refactoringui.com/'
      }
    ]
  },
  {
    categoryName: 'Dev Resources',
    links: [
      {
        title: 'Git Explorer',
        url: 'https://gitexplorer.com/'
      },
      {
        title: 'Can I Use',
        url: 'https://caniuse.com/'
      },
      {
        title: 'Free Background Videos',
        url: 'https://coverr.co/'
      },
      {
        title: 'Streamline Icons',
        url: 'https://www.streamlineicons.com/'
      },
      {
        title: 'Favicon Generator',
        url: 'https://realfavicongenerator.net/'
      },
      {
        title: 'blobmaker for svg shapes',
        url: 'https://www.blobmaker.app/'
      }
    ]
  },
  {
    categoryName: 'CSS Tools',
    links: [
      {
        title: 'Cubic Bezier Generator',
        url: 'http://cubic-bezier.com/'
      },
      {
        title: 'CSS Clip-Path Maker',
        url: 'http://bennettfeely.com/clippy/'
      },
      {
        title: 'Easing Functions List',
        url: 'https://easings.net/'
      },
      {
        title: 'CSS Animation Types',
        url: 'http://animista.net/'
      },
      {
        title: 'Useful :nth-child Recipes',
        url: 'https://css-tricks.com/useful-nth-child-recipies/'
      }
    ]
  },
  {
    categoryName: 'Design Tools and Resources',
    links: [
      {
        title: 'Free SVG Illustrations',
        url: 'https://undraw.co/'
      },
      {
        title: 'Printable Sketch Sheet Templates',
        url: 'https://sketchsheets.com/'
      },
      {
        title: 'Vector Icons',
        url: 'https://www.flaticon.com/'
      },
      {
        title: 'Flat Colors',
        url: 'http://www.flatuicolorpicker.com/'
      },
      {
        title: 'Fonts In Use',
        url: 'https://fontsinuse.com/'
      },
      {
        title: 'Color Palette Generator',
        url: 'https://mycolor.space/'
      },
      {
        title: 'UI Gradients Generator',
        url: 'https://uigradients.com/'
      },
      {
        title: 'Color Shades Generator',
        url: 'http://www.0to255.com/'
      },
      {
        title: 'Sketch App Resources',
        url: 'https://www.sketchappsources.com/'
      },
      {
        title: 'Illustration Creator',
        url: 'https://www.humaaans.com/'
      },
      {
        title: 'Free Stock Photos',
        url: 'https://www.pexels.com/'
      },
      {
        title: 'Official Brand Color Codes',
        url: 'https://brandcolors.net/'
      },
      {
        title: 'Real content for Designs',
        url: 'https://www.lists.design/'
      },
      {
        title: 'Free Outline Iconset',
        url: 'http://linea.io/'
      },
      {
        title: 'Free Photos',
        url: 'https://unsplash.com/'
      },
      {
        title: 'Name That Color',
        url: 'http://chir.ag/projects/name-that-color/'
      }
    ]
  },
  {
    categoryName: 'Design Inspirations',
    links: [
      {
        title: 'best web pages',
        url: 'https://www.pages.xyz/'
      },
      {
        title: 'awesome websites',
        url: 'https://land-book.com/'
      },
      {
        title: 'Call To Idea',
        url: 'https://calltoidea.com/'
      }
    ]
  },
  {
    categoryName: 'General Tools',
    links: [
      {
        title: 'Text Case Converter',
        url: 'https://convertcase.net/'
      },
      {
        title: 'Image Size Compressor',
        url: 'https://tinypng.com/'
      }
    ]
  }
]

export default Resources



// WEBPACK FOOTER //
// ./src/data/data.resources.js